import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ApiService} from 'src/app/services/api/api.service';
import {StaticValuesUtils} from '../../utils/static-values/static-values.utils';
import {ActivatedRoute} from '@angular/router';
import {Distribution} from '../../shared/models/domain/distribution';
import {TripsService} from '../../services/trips/trips.service';
import {AppSettingsService} from '../../services/app-settings/app-settings.service';
import {ScreenUtils} from '../../utils/screen.utils';
import {I18nPluralPipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {Disclaimer} from '../../shared/models/domain/disclaimer';
import {NewrelicService} from '../../services/newrelic/newrelic.service';
import {UpaService} from '../../services/upa/upa.service';
import {GenericEvent} from '../../models/genericEvent';
import {LoyaltyMode} from '@shopping-angular-components/loyalty';
import {Item} from '../../shared/models/domain/item';
import {DiscountByDeal} from '../../shared/models/domain/discountByDeal';
import {PointsInfoUtils} from '../../utils/pointsInfoUtils';
import {Utils} from '../../utils/utils';
import {SearchboxV2Service} from '@shopping-angular-components/searchbox-v2';
import {CROSS_SELLING_COUPON_COOKIE_NAME, BEST_TACTIC_DISCOUNTS} from 'src/app/utils/constants/constants';
import { PriceDetailModalComponent } from '../modal/price-detail-modal/price-detail-modal.component';
import { PriceboxData } from 'src/app/shared/models/domain/pricebox-data';

@Component({
    selector: 'ds-cluster-pricebox',
    templateUrl: './cluster-pricebox.component.html',
    styleUrls: ['./cluster-pricebox.component.scss'],
})
export class ClusterPriceboxComponent implements OnInit, OnChanges {
    @Input() priceboxData: PriceboxData;
    @Input() loyaltyMode!: LoyaltyMode;
    @Input() item: Item;
    @Input() cityGid: string;
    
    private passengersQty: number;
    private actualCookies: Object;

    @ViewChild(PriceDetailModalComponent, { static: true })
    priceDetailModal: PriceDetailModalComponent;
    
    comesFromOffers: boolean;
    serviceTypeText: string;
    isLoading: boolean = false;
    disclaimerText: string;
    locale: string;    
    showCartButton: boolean = false;
    isDiscountByDeals: boolean = false;
    discountByDeals: DiscountByDeal;
    bookingCurrency: string;

    private sharedFromOffersMessages: any = {
        '=1': 'cluster-pricebox.fare.shared.singular.offers',
        other: 'cluster-pricebox.fare.shared.plural.offers',
    };

    private sharedMessages: any = {
        '=1': 'cluster-pricebox.fare.shared.singular',
        other: 'cluster-pricebox.fare.shared.plural',
    };

    hasCrossSellingCoachmark: boolean;

    CROSS_SELLING_COUPON_COOKIE_NAME = CROSS_SELLING_COUPON_COOKIE_NAME;
    BEST_TACTIC_DISCOUNTS = BEST_TACTIC_DISCOUNTS;

    coachmarkTitle: string;
    coachmarkDescription: string;
    isPartner: boolean;
    isPartnerDualPriceLayoutEnabled: boolean;

    constructor(
        private apiService: ApiService,
        private activatedRoute: ActivatedRoute,
        private tripsService: TripsService,
        private appSettingsService: AppSettingsService,
        private i18nPlural: I18nPluralPipe,
        private translateService: TranslateService,
        private searchboxV2Service: SearchboxV2Service,
        private newRelicService: NewrelicService,
        private upaService: UpaService
    ) {}

    ngOnInit(): void {
        this.setCoachmarkData();
        this.passengersQty = this.getPassengerQty();
        this.comesFromOffers = !!this.activatedRoute.snapshot.queryParams['fromOffers'];
        this.setServiceTypeText();
        this.disclaimerText = this.getDisclaimerText();
        this.locale = this.appSettingsService.getLocale();
        this.cargarActualCookies();
        this.showCartButton = StaticValuesUtils.getCartActivation();
        this.isPartner = StaticValuesUtils.isPartner();
        this.isPartnerDualPriceLayoutEnabled = StaticValuesUtils.isPartnerDualPriceLayoutEnabled();
        this.setDiscountByDeal();
        this.bookingCurrency = this.resolveBookingCurrencyIfApply() ;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['item'] && !changes['item'].firstChange) {
            this.setCoachmarkData();
        }
    }

    /*Ahora el pintado del precio total es condicionado*/
    get getTotalPrice(): number {        

        if (!this.isRedemptionEnabled() || this.showDualPriceLayout()) {
            if (this.isDiscountByDeals) {
                return this.priceboxData.prices[this.currency].totalCostWithDeal;
            }
            return this.priceboxData.prices[this.currency].totalPrice;
        }
    }

    public getTotalPriceWhenRedemptionIsEnabled(): number {
        if (this.isRedemptionEnabled() && typeof this.item.loyalty.redemption !== 'undefined' && this.item.loyalty.redemption.summary != null) {
            if (this.isDiscountByDeals) {
                return this.item.loyalty.redemption.summary[this.currency].toPayWithDeal;
            }
            else {
                return this.item.loyalty.redemption.summary[this.currency].toPay;
            }
        }
    }

    public getCurrencySymbol(): string {
        return StaticValuesUtils.getCurrencySymbol(this.currency);
    }

    public isRedemptionEnabled(): boolean {
        return this.item.loyalty?.redemption && this.loyaltyMode === LoyaltyMode.REDEMPTION;
    }

    public isDescriptionDefined(): boolean {
        return this.item.loyalty !== null && this.item.loyalty.redemption !== null;
    }

    public getPoints(): number {
        return PointsInfoUtils.getPoints(this.item.trackingLoyalty.points, this.loyaltyMode);
    }

    public getProduct(): string {
        return this.appSettingsService.getProduct();
    }

    public getFlow(): string {
        return this.appSettingsService.getFlow();
    }

    public getLocale(): string {
        return this.appSettingsService.getLocale();
    }

    public getThousandSeparator() {
        return this.appSettingsService.getThousandSeparator();
    }
    public getScoringPoint() {
        if (this.item.scoringPoints != null) {
            if (this.currency == this.item.scoringPoints[0].currency) {
                return this.item.scoringPoints[0].point;
            } else {
                return this.item.scoringPoints[1].point;
            }
        }
        return null;
    }

    public loyaltyInfoMustBeRendered(): boolean {
        if (this.loyaltyMode !== LoyaltyMode.COUNTRY_OFF && !this.appSettingsService.isWebview() && !!this.item.trackingLoyalty?.points) {
            const accrualPoints = this.getPoints();
            return accrualPoints != null && accrualPoints > 0;
        }
        return false;
    }
    

    private cargarActualCookies(): void {
        this.actualCookies = Utils.getActualCookiesAsObject();
    }

    public goToCheckout(): void {
        let webViewAndCheckoutNativeStack: boolean = false;
        let featuresCookieKey: string = 'xdesp-AppFeatures';
        Object.keys(this.actualCookies).forEach((key: string) => {
            if (key === featuresCookieKey) {
                let cookiesAppFeatures: string[] = this.actualCookies[key].split('|');
                if (
                    cookiesAppFeatures.indexOf('checkoutNativeStack') > -1 ||
                    this.actualCookies[key] === 'checkoutNativeStack'
                ) {
                    webViewAndCheckoutNativeStack = true;
                }
            }
        });
        this.isLoading = true;
        if (webViewAndCheckoutNativeStack) {
            (async () => {
                await this.delay(2000);
                this.isLoading = false;
            })();
        }

        const errorUrl = 'https://' + window.location.host + '/transfer/shopping/error/';
        const site = this.appSettingsService.getSite();
        const lang = this.appSettingsService.getLanguage();
        let items;
        if (this.priceboxData.hashFirstRoute != null && this.priceboxData.hashSecondRoute != null) {
            items = [
                {
                    trackingId: this.priceboxData.trackingId,
                    hashFirstRoute: this.priceboxData.hashFirstRoute,
                    hashSecondRoute: this.priceboxData.hashSecondRoute,
                },
            ];
        } else {
            items = [{ trackingId: this.priceboxData.trackingId, hash: this.priceboxData.hash }];
        }

        this.tripsService.goToCheckout(items, site, lang, this.currency, errorUrl, this.discountByDeals?.id, this.resolveBookingCurrencyIfApply());
    }

    private delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public trackBuyEvt(): void {
        this.trackNewRelicBuyEvt();
        this.trackUpaBuyEvt(this.priceboxData.order);
    }

    public isMobile(): boolean {
        return ScreenUtils.isMobile() || ScreenUtils.isMobileS();
    }

    public fillSearchBoxData(): void {
        if (this.isMobile()) {
            this.searchboxV2Service.highlightSearchbox.emit();
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    public shouldShowNetPrice(): boolean {
        return this.getNetPrice() != null && !this.isPartner && !this.isRedemptionEnabled();
    }

    /**
     * Shows dual price layout: total price and price after redemption (paying with points).
     * Enabled only for partners with dual price display configured.
     */
    public showDualPriceLayout(): boolean {
        return this.isPartner && this.isPartnerDualPriceLayoutEnabled;
    }

    public getNetPrice(): number | undefined {
        return this.priceboxData.prices[this.currency].localTaxes?.netPrice;
    }

    private getPassengerQty(): number  {
        const distribution: Distribution = this.apiService.getCurrentDistribution();
        return parseInt(distribution.adults) + this.getChildrenQty(distribution.children);
    }

    private getChildrenQty(children): number {
        if (children) {
            return children.split(',').length;
        } else return 0;
    }

    private trackNewRelicBuyEvt(): void {
        this.newRelicService.trackToInsights('Buy', {
            channel: this.appSettingsService.getChannel(),
            site: this.appSettingsService.getSite(),
            lang: this.appSettingsService.getLanguage(),
            userId: this.appSettingsService.getUserId(),
        });
    }

    private trackUpaBuyEvt(index): void {
        this.upaService.track(
            GenericEvent.newUserAction('buy', 'click', {
                currency: this.currency,
                type: this.resolveTransferServiceType(),
                order: index,
                channel: this.appSettingsService.getChannel(),
                site: this.appSettingsService.getSite(),
                lang: this.appSettingsService.getLanguage(),
                userId: this.appSettingsService.getUserId(),
            })
        );
    }

    private getSelectedCurrency(): string {
        return this.priceboxData.currencies.find(currency => {
            return currency.selected;
        }).value;
    }

    get currency(): string {
        return this.getSelectedCurrency();
    }

    private setServiceTypeText(): void {
        const coverageMsg: string = this.translateMsg('cluster-pricebox.coverage.' + this.priceboxData.coverage);
        const sinceMsg: string = this.translateMsg('shared.since');

        let finalMessage: string;

        if (this.isTransferShared()) {
            finalMessage = this.getSharedServiceText();
        }
        if (this.isTransferPrivate()) {
            finalMessage = this.getPrivateServiceText();
        }

        finalMessage += `, ${coverageMsg}`;
        if (this.comesFromOffers) finalMessage += `, ${sinceMsg}`;

        this.serviceTypeText = finalMessage;
    }

    private getSharedServiceText(): string {
        let messageKey: string;
        if (this.comesFromOffers) {
            messageKey = this.i18nPlural.transform(this.passengersQty, this.sharedFromOffersMessages);
        } else {
            messageKey = this.i18nPlural.transform(this.passengersQty, this.sharedMessages);
        }
        return this.translateMsg(messageKey, { number: this.passengersQty });
    }

    private getPrivateServiceText(): string {
        let messageKey: string;
        if (this.comesFromOffers) {
            messageKey = 'cluster-pricebox.fare.private.offers';
        } else {
            messageKey = 'cluster-pricebox.fare.private';
        }

        return this.translateMsg(messageKey);
    }

    private translateMsg(key: string, params?: Object): string {
        return this.translateService.instant(key, params);
    }

    private getDisclaimerText(): string {
        let disclaimer: Disclaimer = this.priceboxData.prices[this.currency].disclaimer;
        let text: string;
        if (disclaimer) {
            if (this.appSettingsService.getSite() === 'AR') {
                text = disclaimer.taxesMessage;
            }
        }
        return text;
    }

    private isTransferShared(): boolean {
        return this.priceboxData.transferServiceType === 'SHARED';
    }

    private isTransferPrivate(): boolean {
        return this.priceboxData.transferServiceType === 'PRIVATE';
    }

    private resolveTransferServiceType(): string {
        if (this.isTransferPrivate()) {
            return 'PRIVATE';
        }
        if (this.isTransferShared()) {
            return 'SHARED';
        }
        return 'UNDEFINED';
    }

    onCloseCoachmark(): void {
        this.hasCrossSellingCoachmark = false;
    }

    private setCoachmarkData(): void {
        this.hasCrossSellingCoachmark = this.item.hasCoachmark && !!this.item.promotion?.type;

        this.coachmarkTitle = this.translateService.instant('cluster-pricebox.coachmark.title');
        this.coachmarkDescription = this.translateService.instant('cluster-pricebox.coachmark.description');
    }

    /*Ahora hay que intercambiar originalTotalPrice con totalPrice, ya que el descuento funel es solo visual (No debe ir a checkout) y puede existir descuento de cupon */
    get originalTotalPrice(): number {
        if (this.isDiscountByDeals) {
            return this.priceboxData.prices[this.currency].totalPrice;
        } else {
            return this.priceboxData.prices[this.currency].originalTotalPrice;
        }
    }

    get originalTotalPriceWhenRedemptionIsEnabled(): number {
        if (this.isDiscountByDeals) {
            return this.item.loyalty.redemption.summary[this.currency].toPay;
        } else {
            return this.priceboxData.prices[this.currency].originalTotalPrice;
        }
    }

    private setDiscountByDeal(): void {
       if (this.priceboxData.payments) {
          const paymentDeal = this.priceboxData.payments.find(p => p.type == BEST_TACTIC_DISCOUNTS);  //Tipo de descuento para upper funnel
          this.discountByDeals = { id: paymentDeal.id, paymentMethodsDescription: paymentDeal.methods.map(m => m.description).join(', ') };
          this.isDiscountByDeals = true;
       }
   }

   private resolveBookingCurrencyIfApply(): string {
        if (this.priceboxData?.bimonetary && this.currency === 'USD') {
            return this.currency;
        }
        return null;
    }
}
